import type { ConfirmFn, NotifyFn } from "@heraion/ui";

// THE web implementation of the shared confirm/notify seams — one per host, not
// one per surface. Maxes, Measurements and the CO-7 coach target editor all
// inject these; before the CO-7 consolidation each surface carried its own
// near-identical copy. react-native's Alert is a no-op on react-native-web,
// which is why these exist at all.
//
// Copy is resolved by the caller (shared i18n): the seam owns the mechanism only.

// The `typeof window` guard keeps these safe under a non-DOM render (SSR/tests):
// no window → no confirmation → FALSE, never an accidental yes.
export const confirmViaWindow: ConfirmFn = ({ title, body }) =>
  Promise.resolve(
    typeof window !== "undefined" ? window.confirm(`${title}\n\n${body}`) : false,
  );

export const notifyViaWindow: NotifyFn = (title, body) => {
  if (typeof window !== "undefined") window.alert(`${title}\n\n${body}`);
};
